import { getGeoIP } from './geoip'

declare const SI_API_URL: string
declare const SI_API_URL_CA: string

const fallbackUrls: Record<string, string> = {
  'checkout.stickerit.co': 'https://pricingcalculator.stickerit.co',
  'checkout.staging-wp.stickerit.co':
    'https://staging-pricingcalculator.stickerit.co',
}

const getFallbackUrl = () => {
  try {
    return fallbackUrls[window.location.hostname] + '/cart'
  } catch (err) {
    return fallbackUrls['checkout.stickerit.co'] + '/cart'
  }
}

const northAmerica = ['US', 'CA', 'MX', 'PR', 'JP', 'CR']

const apiForCountry = (countryCode?: string) => {
  try {
    if (!countryCode) {
      return SI_API_URL
    }

    if (northAmerica.includes(countryCode)) {
      return SI_API_URL_CA
    }

    return SI_API_URL
  } catch {
    return getFallbackUrl()
  }
}

export const getAPIUrl = (path: string) => {
  return getGeoIP().then((countryCode) => {
    return apiForCountry(countryCode) + path
  })
}
